export default function Default() {
  return (
    <div className="border-b border-b-white/08 rounded-lg flex items-center gap-2 bg-white/08 p-2 transition-200 click-button">
      <div className="relative skeleton w-[90px] h-[58px] rounded-md shrink-0"></div>
      <div className="w-full">
        <div className="flex items-start mb-2.5 justify-between">
          <div className="flex items-start justify-start gap-2 flex-col w-full ">
            <h2 className="font-semibold rounded-md skeleton h-3 w-[80%] text-base text-white leading-130"></h2>
            <p className="text-xs rounded-md skeleton w-1/2 h-2 font-normal leading-130"></p>
          </div>
          <div
            className="mt-1 flex w-[47px] shrink-0 h-[17px] skeleton rounded-full justify-between  items-center"></div>
        </div>
        <div className="h-1 rounded-lg transition-all skeleton duration-1000 bg-white/08">
          <div className="rounded-lg h-full"></div>
        </div>
      </div>
    </div>
  );
}
